import {
	Component,
	EventEmitter,
	Input,
	OnInit,
	Output,
	ViewChild
} from '@angular/core';

import { ISidebarToggleEvent, VbUiSidebarComponent } from './VbUiSidebar.Component';
import { IRules } from '../css/CssRules.Contract';
import { getMobileSidebarLayoutStyles } from './VbUiSidebarLayoutMobileStyles';

import styles from './VbUiSidebarLayout.Component.module.less';

export enum VbUiSidebarLayoutSlot {
	MAIN_CONTENT = 'mainContent',
	SIDEBAR = 'sidebar'
}

@Component({
	selector: 'vb-ui-sidebar-layout',
	templateUrl: './VbUiSidebarLayout.Component.html',
	host: {
		'[class]': 'styles.root',
		'layout-gt-md': 'row',
		'layout-wrap': 'false'
	},
	standalone: false
})
export class VbUiSidebarLayoutComponent implements OnInit {
	@Input() public noBorder: boolean;
	@Input() public hasLowerContent: boolean;
	@Input() public mobileLayoutBreakPointSize: number;
	@Input() public disableMobileLayout: boolean;
	@Output() public onSidebarToggle = new EventEmitter<ISidebarToggleEvent>();
	@ViewChild('sidebar') public sidebarComponent: VbUiSidebarComponent;

	public readonly styles = styles;
	public mainContentClass: string;
	public hostClass: { [key: string]: boolean };
	public cssRules: IRules;

	public ngOnInit(): void {
		this.cssRules = this.disableMobileLayout ? null :
			getMobileSidebarLayoutStyles(this.mobileLayoutBreakPointSize);
	}
}
